import CheckoutPage from 'dispensary/checkout';

export default CheckoutPage;
